import { UPDATE_BEDSTATUS_VIEW, GET_BEDSTATUS_VIEW } from '../../constant';

export const updateBedStatusViewVal = (viewVal) => ({
  type: UPDATE_BEDSTATUS_VIEW,
  viewVal,
});

export const getBedStatusViewVal = () => ({
  type: GET_BEDSTATUS_VIEW,
});
